import request from "@/utils/request";

// 未登录获取直播列表
export function getHeroLiveList(data) {
  return request({
    url: "/app/zhkt/live/v1/hero/query/liveList",
    method: "post",
    data: data,
  });
}

// 课程列表
export function getSubjectList(data) {
  return request({
    url: `/base/course/v1/list`,
    method: "post",
    data: data,
  });
}

// 院系列表
export function gradeList(queryName) {
  return request({
    url: `/base/dict/data/v1/getDeptUsers?queryName=${queryName}`,
    method: "get",
  });
}

// 获取直播流地址
export function getStreamLive(data, schoolId) {
  return request({
    url: `/app/zhkt/live/v1/get/live/stream?liveId=${data}&schoolId=${schoolId}`,
    method: "get",
  });
}

// 用户对直播间相关操作
export function operateLive(data) {
  return request({
    url: `/app/zhkt/live/v1/user/operate/live`,
    method: "post",
    data: data,
  });
}

// 创建聊天室
export function createGroup(data) {
  return request({
    url: `/base/baseImGroup/v1/createGroup`,
    method: "post",
    data: data,
  });
}

// 获取聊天室列表
export function getGroupList(data, groupType) {
  return request({
    url: `/base/baseImGroup/v1/getGroupList?userId=${data}&groupType=${groupType}`, // groupType:群类型 1班级群 2直播群
    method: "get",
  });
}

// 加入聊天室
export function joinGroup(data) {
  return request({
    url: `/base/baseImGroup/v1/joinGroup`,
    method: "post",
    data: data,
  });
}

// 查询聊天记录
export function getPageMessageInfo(data) {
  return request({
    url: `/base/baseImGroup/v1/pageMessageInfo`,
    method: "post",
    data: data,
  });
}

// 退出聊天
export function exitGroup(data) {
  return request({
    url: `/base/baseImGroup/v1/exitGroup`,
    method: "post",
    data: data,
  });
}

// 获取直播回放列表（登录后调）
export function getPlaybackList(data) {
  return request({
    url: `/app/zhkt/live/playback/v1/query/playback/list`,
    method: "post",
    data: data,
  });
}

// 我的互动列表
export function deliverClassMyPage(data) {
  return request({
    url: `/app/zhkt/deliver/class/v1/myPage`,
    method: "post",
    data: data,
  });
}

// 互动直播排行榜
export function getViverNumberOrder(data) {
  return request({
    url: `/app/zhkt/deliver/class/getViverNumberOrder`,
    method: "post",
    data: data,
  });
}

// 获取直播回放列表（未登录）
export function getHeroPlaybackList(data) {
  return request({
    url: `/app/zhkt/live/playback/v1/hero/query/playback/list`,
    method: "post",
    data: data,
  });
}

// 获取回放流地址
export function getPlaybackUrl(data) {
  return request({
    url: `/app/zhkt/live/playback/v1/hero/query/playback/url?playbackId=${data}`,
    method: "get",
  });
}

// 保存打点信息
export function SaveDot(data) {
  return request({
    url: `/app/zhkt/live/playback/dot/v1/save/dot`,
    method: "post",
    data: data,
  });
}

// 查询打点信息(登录)
export function getDot(data) {
  return request({
    url: `/app/zhkt/live/playback/dot/v1/query/dot?businessId=${data}`,
    method: "get",
  });
}
// 查询打点信息(未登录)
export function getnoHeaderHeroDot(data) {
  return request({
    url: `/app/zhkt/live/playback/dot/v1/hero/query/dot/noHeader?businessId=${data.businessId}&schoolId=${data.schoolId}`,
    method: "get",
  });
}
//删除回放打点
export function deleteDot(playbackDotId) {
  return request({
    url: `/app/zhkt/live/playback/dot/v1/delete/dot?playbackDotId=${playbackDotId}`,
    method: "get",
  });
}

// 查询打点列表(未登录)
export function getHeroDot(data) {
  return request({
    url: `/app/zhkt/live/playback/dot/v1/hero/query/dot?businessId=${data}`,
    method: "get",
  });
}

// 直播心跳统计(5秒掉一次)
export function livHeartbeat(data) {
  return request({
    url: `/app/zhkt/stat/v1/hero/online/heartbeat`,
    method: "post",
    data: data,
  });
}

// 直播详情(未登录)
export function liveHeroById(data) {
  return request({
    url: `/app/zhkt/live/v1/query/live/byId/front?liveId=${data.liveId}&schoolId=${data.schoolId}`,
    method: "get",
  });
}

// 获取语音转写信息(登录)
export function getVoiceList(data) {
  return request({
    url: `/ai/voice/v1/getVoiceList?name=${data.name}&id=${data.id}&pageSize=${data.pageSize}&pageNumber=${data.pageNumber}&role=${data.role}`,
    method: "post",
  });
}

// 编辑“语音转写”
export function setitemlist(data) {
  return request({
    url: "/ai/voice/v1/editVoice",
    method: "post",
    data: data,
  });
}
// 获取高频词列表(登录)
export function getHotWordsList(data) {
  return request({
    url: `/ai/voice/v1/getHotWordsList?id=${data}`,
    method: "post",
  });
}

// 获取语音转写信息(未登录)
export function getHeroVoiceList(data) {
  return request({
    url: `/ai/voice/v1/hero/getVoiceList?name=${data.name}&id=${data.id}&pageSize=${data.pageSize}&pageNumber=${data.pageNumber}&role=0`,
    method: "post",
  });
}

// 获取高频词列表(未登录)
export function getHeroHotWordsList(data) {
  return request({
    url: `/ai/voice/v1/hero/getHotWordsList?id=${data}`,
    method: "post",
  });
}

// 获取“语气词”信息 列表
export function getToneList(data) {
  return request({
    url: `/ai/voice/v1/getToneList`,
    method: "post",
    data: data,
  });
}

// 获取群公告
export function getGroupAnnouncement(groupId) {
  return request({
    url: `/base/baseImGroup/v1/getGroupAnnouncement?groupId=${groupId}`,
    method: "get",
  });
}

// 读取公告
export function readMsg(data) {
  return request({
    url: `/base/baseImGroup/v1/readMsg?announcementId=${data.id}&groupId=${data.groupId}&userId=${data.userId}`,
    method: "get",
  });
}

// 前台-在线课堂-获取直播回放
export function getplaybackinfo(liveId, schoolId) {
  return request({
    url: `/app/zhkt/live/v1/front/get/playback/info?liveId=${liveId}&schoolId=${schoolId}`,
    method: "get",
  });
}
// 前台-在线课堂-获取录播机回放资源
export function getCameraPlaybackInfo(liveId, schoolId){
  return request({
    url: `/app/zhkt/live/v1/front/get/camera/playback/info?liveId=${liveId}&schoolId=${schoolId}`,
    method: "get",
  });
}

// 用户加入直播间(未登录)
export function noLoginJoinLive(data) {
  return request({
    url: `/app/zhkt/live/v1/hero/user/join/live?liveId=${data.liveId}&password=${data.password}`,
    method: "get",
  });
}

// 删除聊天记录
export function delImMessageById(id) {
  return request({
    url: `/base/baseImGroup/v1/delImMessageById?id=${id}`,
    method: "get",
  });
}

// 下载语音实录
export function downloadVoiceList(data) {
  return request({
    url: `/ai/voice/v1/hero/downloadVoiceList?id=${data.id}&name=${data.name}`,
    method: "get",
  });
}
